import { gql } from "@stadium/services/apollo-client";

export const ADDRESS_DETAILS = gql`
  fragment AddressDetails on Address {
    externalId: id
    address1
    address2
    city
    countryName
    default
    firstname
    lastname
    businessName
    phone
    stateName
    stateNameNonUs
    countryId
    zipcode
    zipcodeNonUs
    stateAbbreviation
  }
`;
